'use client';

import dynamic from 'next/dynamic';

const isSuite = process.env.NEXT_PUBLIC_MYARCHITECTURE_SUITE === 'true';

const HubLandingPage = dynamic(() => import('@/components/hub/HubLandingPage'));
const CodeArchaeologyPage = dynamic(() => import('./codearchaeology/page'));

export default function RootPage() {
  return isSuite ? <HubLandingPage /> : <CodeArchaeologyPage />;
}
